
import { Vue, Options } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { RouteLocation } from "vue-router";
import AnalyticsPieChart from "../atoms/AnalyticsPieChart.vue";
import { StatsApi, GetSummaryResponse } from "../../autogen";
import HumanSkillChart from "../atoms/HumanSkillChart.vue";
import TrendSummaryChart from "../atoms/TrendSummaryChart.vue";
import CulturalFitChart from "../molecules/CulturalFitChart.vue";
import DataNotFound from "../atoms/DataNotFound.vue";
import Store from "../../store";
import { InstructionLevel } from "../../types";
import Page from "../molecules/Page.vue";
@Options({
  components: {
    AnalyticsPieChart,
    HumanSkillChart,
    TrendSummaryChart,
    CulturalFitChart,
    DataNotFound,
    Page
  }
})
export default class Dashboard extends Vue {
  private readonly storeInstance = Store.getInstance();
  chartData?: GetSummaryResponse = {
    PersonalityMatrix: [],
    PMAnalytics: [],
    RDAnalytics: [],
    PersonalityActivityMotivation: [],
    HumanSkill: [],
    CulturalFit: []
  };
  departmentId?: string;
  notFound = false;
  selectedDepartmentPath: string = "";
  async draw() {
    this.notFound = false;
    const departmentId = this.$route.params["departmentId"] as string;
    if (this.departmentId === departmentId) return;
    this.departmentId = departmentId;
    try {
      const response = await new StatsApi().getDepartmentSummary({
        departmentId
      });
      this.chartData = response.data;
    } catch (err) {
      this.notFound = true;
      if (err.response.status !== 404) {
        Store.getInstance().setInstructionContent(InstructionLevel.Alert, "エラーが発生しました");
      }
    }
  }
  updated() {
    this.draw();
  }
  mounted() {
    this.draw();
    this.setDepartmentPath();
  }
  @Watch("$route")
  async onRouteChanged(to: RouteLocation) {
    const path = to.path.split("/").filter(Boolean);
    if (path.slice(-1)[0] === "dashboard") {
      this.setDepartmentPath();
    }
  }
  setDepartmentPath() {
    const departmentId = this.$route.params["departmentId"] as string;
    this.selectedDepartmentPath = this.storeInstance.getDepartmentPath(departmentId);
  }
}
